import React, { useEffect, useState, useCallback } from "react";
import { Plus, Trash2, Edit3, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const empty = { title: "", excerpt: "", content: "", cover_image: "", author: "DCS Electro", published: true };

export default function AdminBlog() {
  const [rows, setRows] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = useCallback(() => { api.get("/admin/blog").then((r) => setRows(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const set = (k) => (e) => {
    const v = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((f) => ({ ...f, [k]: v }));
  };
  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing === "new") await api.post("/admin/blog", form);
      else await api.put(`/admin/blog/${editing.id}`, form);
      toast.success("Article enregistré"); setEditing(null); load();
    } catch (err) { toast.error("Erreur", { description: err.response?.data?.detail || err.message }); }
  };
  const del = async (p) => { if (!window.confirm("Supprimer cet article ?")) return; await api.delete(`/admin/blog/${p.id}`); toast.success("Supprimé"); load(); };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-heading text-3xl font-extrabold">Articles</h1>
        <button onClick={() => { setForm(empty); setEditing("new"); }} className="flex items-center gap-2 bg-sapphire text-white px-5 py-2.5 font-semibold" data-testid="admin-new-blog"><Plus size={18} /> Nouvel article</button>
      </div>
      <div className="bg-white border border-gray-200">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-gray-500"><tr><th className="p-4">Titre</th><th className="p-4">Auteur</th><th className="p-4">Publié</th><th className="p-4"></th></tr></thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.id} className="border-t border-gray-100">
                <td className="p-4 font-medium">{p.title}</td>
                <td className="p-4 text-gray-500">{p.author}</td>
                <td className="p-4">{p.published ? <span className="text-green-600">Oui</span> : <span className="text-gray-400">Brouillon</span>}</td>
                <td className="p-4"><div className="flex gap-2 justify-end">
                  <button onClick={() => { setForm(p); setEditing(p); }} className="p-2 text-gray-500 hover:text-sapphire"><Edit3 size={16} /></button>
                  <button onClick={() => del(p)} className="p-2 text-gray-500 hover:text-red-500"><Trash2 size={16} /></button>
                </div></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-gray-400">Aucun article.</td></tr>}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setEditing(null)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={save} className="bg-white w-full max-w-2xl max-h-[90vh] overflow-auto p-8" data-testid="admin-blog-form">
            <div className="flex items-center justify-between mb-6"><h2 className="font-heading text-2xl font-bold">{editing === "new" ? "Nouvel article" : "Modifier"}</h2><button type="button" onClick={() => setEditing(null)}><X /></button></div>
            <div className="space-y-4">
              <div><label className="block text-sm font-medium mb-1">Titre *</label><input value={form.title} onChange={set("title")} required className="w-full border border-gray-300 px-4 py-2.5" data-testid="blog-title" /></div>
              <div><label className="block text-sm font-medium mb-1">Extrait</label><input value={form.excerpt} onChange={set("excerpt")} className="w-full border border-gray-300 px-4 py-2.5" /></div>
              <div><label className="block text-sm font-medium mb-1">Image de couverture (URL)</label><input value={form.cover_image} onChange={set("cover_image")} className="w-full border border-gray-300 px-4 py-2.5" /></div>
              <div><label className="block text-sm font-medium mb-1">Contenu (HTML) *</label><textarea value={form.content} onChange={set("content")} required rows={8} className="w-full border border-gray-300 px-4 py-2.5 font-mono text-xs" data-testid="blog-content" /></div>
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.published} onChange={set("published")} /> Publié</label>
            </div>
            <div className="flex gap-3 mt-8"><button type="submit" className="flex-1 bg-sapphire text-white font-semibold py-3" data-testid="blog-save">Enregistrer</button><button type="button" onClick={() => setEditing(null)} className="px-6 border border-gray-300 font-semibold">Annuler</button></div>
          </form>
        </div>
      )}
    </div>
  );
}
